var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"washing-symbol",class:_vm.withBorder ? 'border' : ''},[_c('v-img',{attrs:{"src":_vm.image,"width":"30px","height":"30px","contain":"","aspect-ratio":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }